export default __webpack_public_path__ + "static/media/arrowColorful.d26a23f0.svg";